import React, { Component } from 'react';
import './Modal.css';
import { inject, observer } from 'mobx-react';

import { Flex, Box } from 'grid-styled';

import ModalSelect from './ModalSelect';
import { LabelInput } from './LabelInput';

import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';

import Background from '../assets/alert-circle.png';

class StreamDestinationModal extends Component {
    componentDidMount() {
        // this.props.validateModel();
    }

    validateModel = () => {
        const { model } = this.props;

        let validationVariable = model.validateModelByModal('destination');

        let validationObject = {};

        if (validationVariable.length > 0) {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: false
            });
        } else {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: true
            });
        }
    };

    render() {
        const { model, updateState, statevariable } = this.props;

        return (
            <Box>
                <Flex>
                    <Box w={2 / 3}>
                        <ModalSelect
                            label="Server Type"
                            model={model}
                            name="servertypeselect"
                            statevariable={statevariable}
                            validateModel={this.props.validateModel}
                            updateState={updateState}
                            errormask={
                                statevariable.formErrors.servertypeselect
                            }
                            background={Background}
                            optionsName={['Icecast Server', 'Icecast Source']}
                            optionsValue={['server', 'source']}
                        />{' '}
                        <Box pt={'3px'} pb={'3px'}>
                            <LabelInput
                                type="icecastname"
                                label="Icecast Name"
                                model={model}
                                name="icecastname"
                                statevariable={statevariable}
                                updateState={updateState}
                                errormask={statevariable.formErrors.icecastname}
                                background={Background}
                            />
                        </Box>
                        <Box pt={'3px'} pb={'3px'}>
                            <LabelInput
                                type="text"
                                label="Icecast Description"
                                model={model}
                                name="icecastdescription"
                                statevariable={statevariable}
                                updateState={updateState}
                                errormask={
                                    statevariable.formErrors.icecastdescription
                                }
                                background={Background}
                            />
                        </Box>
                        <Box pt={'3px'} pb={'3px'}>
                            <LabelInput
                                type="text"
                                label="Icecast Genre"
                                model={model}
                                name="icecastgenre"
                                statevariable={statevariable}
                                updateState={updateState}
                                errormask={
                                    statevariable.formErrors.icecastgenre
                                }
                                background={Background}
                            />
                        </Box>
                        {model.servertypeselect === 'server' ? (
                            <div>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        type="text"
                                        label="Mount Point"
                                        model={model}
                                        name="mountpoint"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.mountpoint
                                        }
                                        background={Background}
                                    />
                                </Box>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        display="none"
                                        type="text"
                                        label="Remote URL"
                                        model={model}
                                        name="remoteurl"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.remoteurl
                                        }
                                        background={Background}
                                    />
                                </Box>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        display="none"
                                        disabled="true"
                                        type="number"
                                        label="Audio Port"
                                        model={model}
                                        name="audioport"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.audioport
                                        }
                                        background={Background}
                                    />
                                </Box>
                            </div>
                        ) : model.servertypeselect === 'source' ? (
                            <div>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        type="text"
                                        label="Remote URL"
                                        model={model}
                                        name="remoteurl"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.remoteurl
                                        }
                                        background={Background}
                                    />
                                </Box>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        type="number"
                                        label="Audio Port"
                                        model={model}
                                        name="audioport"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.audioport
                                        }
                                        background={Background}
                                    />
                                </Box>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        type="text"
                                        label="Mount Point"
                                        model={model}
                                        name="mountpoint"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.mountpoint
                                        }
                                        background={Background}
                                    />
                                </Box>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        type="text"
                                        label="Username"
                                        model={model}
                                        name="username"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.username
                                        }
                                        background={Background}
                                    />
                                </Box>
                                <Box pt={'3px'} pb={'3px'}>
                                    <LabelInput
                                        type="password"
                                        label="Password"
                                        model={model}
                                        name="password"
                                        statevariable={statevariable}
                                        updateState={updateState}
                                        errormask={
                                            statevariable.formErrors.password
                                        }
                                        background={Background}
                                    />
                                </Box>
                            </div>
                        ) : (
                            <div />
                        )}
                    </Box>
                    <BoxTemplate
                        textalign="left"
                        mr={'15px'}
                        ml={'15px'}
                        w={1 / 3}
                    >
                        <Label textStyle="labelSmall">
                            <b>General</b>
                            <br />
                            The stream will be accessible at http://[Remote
                            URL]:[Audio Port]/[Mount Point]
                            <br />
                            Example: http://192.168.0.24/myIcecastStream
                            <br />
                            <b>Server Type</b>
                            <br />
                            Choose from two options: Icecast Server or Icecast
                            Source
                            <p>
                                In the "Icecast Server" mode, the stream is sent
                                to port 8000 of the built-in Icecast server. The
                                listeners can then listen by connecting to this
                                internal server.
                            </p>
                            <p>
                                In the "Icecast Source" mode, the stream is sent
                                to the destination defined by the options
                                "Remote URL" and "Audio port". In addition, you
                                should provide a username and a password in
                                order to connect to the said destination. The
                                listeners can then listen by connecting to this
                                external server.
                            </p>
                            <b>Icecast Name</b>
                            <br />
                            The Icecast Name is a part of the metadata sent to
                            the Icecast server. This is the "title" of your
                            Stream as it will appear in a media player.
                            <br />
                            <b>Icecast Description</b>
                            <br />
                            This Icecast Description is a part of the metadata
                            sent to the Icecast server. It can contain any
                            static information or message complementing the
                            Icecast Name.
                            <br />
                            <b>Icecast Genre</b>
                            <br />
                            This Icecast Genre is a part of the metadata sent to
                            the Icecast server. It contains information on the
                            type of content of the stream.
                            <br />
                            <b>Mount Point</b>
                            <br />
                            The Mount Point is the last part of the "address" at
                            which the stream can be accessed. An Icecast server
                            can provide several Mount Points on a single port.
                            Note: the Mount Point should not contain spaces
                            <br />
                            <b>Remote URL</b>
                            <br />
                            Enter the URL address the stream will be sent to -
                            either the local server (127.0.0.1) or an Icecast
                            server. Note: only visible for "Icecast Source"
                            mode"
                            <br />
                            <b>Audio Port</b>
                            <br />
                            Enter the port of the Icecast server used to give
                            the listener(s) access to the stream. Note: only
                            visible for "Icecast Source" mode"
                            <br />
                            <b>Username & Password</b>
                            <br />
                            Define a username and a password to enable changes
                            on the Icecast server
                        </Label>
                    </BoxTemplate>
                </Flex>
            </Box>
        );
    }
}

export default inject('model')(observer(StreamDestinationModal));



// WEBPACK FOOTER //
// ./src/form/StreamDestinationModal.js